/**
 * The tag of a container image, "2026.11.04" of
 * "szymonbe/carrier-pigeon:2026.11.04" (#791). An image with no tag is
 * returned whole: the colon of a registry port is not a tag's, nor is a
 * digest's ("@sha256:…"), which is left off.
 */
export const imageTag = (image: string): string => {
  const at = image.indexOf('@');
  const named = at >= 0 ? image.slice(0, at) : image;
  const colon = named.lastIndexOf(':');
  return colon > named.lastIndexOf('/') ? named.slice(colon + 1) : named;
};
